import { render, staticRenderFns } from "./ContractItemButton.vue?vue&type=template&id=0f5b0c66&"
import script from "./ContractItemButton.vue?vue&type=script&lang=js&"
export * from "./ContractItemButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports